<div class="center">
    <img [src]="this.src" />
    <p>{{message}}</p>
</div>